module.exports = __webpack_public_path__ + "static/media/portugues.c931681f.png";